<template>
  <div>
    <div class="tooltip">
      <span class="text">{{ data.label }}</span>
      <div class="tip">
        <div class="label">账号: {{ data.userName }}</div>
        <div class="label">归属部门: {{ data.groupInfo[0].path }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      name: '113'
    }
  }
}
</script>

<style lang="less" scoped>
.tooltip {
  display: inline-block;
  position: relative;
  .tip {
    position: fixed;
    padding: 8px 20px;
    border: 1px solid rgb(225, 223, 223);
    border-radius: 4px;
    background: #fff;
    z-index: 10;
    display: none;
  }
  &:hover {
    .tip {
      display: block;
    }
  }
}
</style>
